import React, { useEffect, useState } from 'react'
import ModalProcedimientosRecordAnestesia from './ModalProcedimientosRecordAnestesia';
import { postPrincipalRecordAnestesia } from '../../../services/AnestesiaRuta';
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../../services/ApiHIS';

const RecordAnestesia = () => {
  const [modalOnProcedimientosQx, setmodalOnProcedimientosQx]=useState(false)
  const [dataUser, setdataUser]=useState([])
  const [dataUserDiligenciar, setdataUserDiligenciar]=useState([])
  const [dataMedico, setdataMedico]=useState([])

  //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

   // Definir el estado inicial de los campos de entrada
  const [formData, setFormData] = useState({
    codigoCirugia: '',
    numeroDeDocumento: '',
    fecha: ''
  });

  // Manejador para actualizar el estado cuando cambian los valores de los campos de entrada
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Manejador para el evento de envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(dataMedico,'dataMedico')
    // Lógica para buscar información con los datos del formulario
    console.log('Form data submitted: ', formData);
    const filtroRecordAnesteasia ={
      "ProMCDpto":"001",
      "ProEmpCod":"1",
      "ProCirCod": formData.codigoCirugia,//"97483",//CODIGO CIRUGIA
      "PersCod":"",//"S0011",//CODIGO MEDICO "M0002"
      "MMNomM": "",//FILTRO NOMBRE MEDICO
      "MPCedu": formData.numeroDeDocumento,//CEDULA PACIENTE 25664039
      "MPNOMC":""//"MANUELA  RIVERA CUETIA"//FILTRO NOMBRE PACIENTE
  }
  postPrincipalRecordAnestesia(filtroRecordAnesteasia).then((res)=>{
    console.log(res.data,'record')
    setdataUser(res.data)
  })
  };

  

  //modal procedimientos de un usario
  const handleOnClickProcedimientos=(item)=>{
    setmodalOnProcedimientosQx(true)
    console.log(item,'informacion')
    setdataUserDiligenciar(item)
  }

  useEffect(()=>{
  //   const filtroRecordAnesteasia ={
  //     "ProMCDpto":"001",
  //     "ProEmpCod":"1",
  //     "ProCirCod":"97483",//CODIGO CIRUGIA
  //     "PersCod":"",//CODIGO MEDICO
  //     "MMNomM": "",//FILTRO NOMBRE MEDICO
  //     "MPCedu": "",//CEDULA PACIENTE
  //     "MPNOMC":"MANUELA  RIVERA CUETIA"//FILTRO NOMBRE PACIENTE
  // }
  //   postPrincipalRecordAnestesia(filtroRecordAnesteasia).then((res)=>{
  //     console.log(res.data,'record')
  //     setdataUser(res.data)
  //   })
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL() 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realizar la solicitud HTTP GET con las cabeceras configuradas
    axios
      .get(url, { headers })
      .then(response => {
       console.log(response.data.user_data,'data user');
       //setdataUserMedico(response.data.user_data)
       localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));
       // Obtener la cadena JSON del localStorage
      const usuarioInfoStr = localStorage.getItem('usuarioInfo');
      // Convertir la cadena JSON a un objeto
      const usuarioInfo = JSON.parse(usuarioInfoStr);
      console.log(usuarioInfo.UsuarioEncriptado,'usuarioInfoStr')
      setdataMedico(usuarioInfo)
      })
      .catch(error => {
        console.error('Error al autenticar al usuario:', error);
      });

  },[])


  return (
    <>
    <label     
     className=" text-2xl text-[#05a29d] font-medium pb-3"
    >
        Record Anestesia
    </label>
    {/* <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">
            Nombre
          </label>
          <input
            type="text"
            name="nombre"
            id="nombre"
            value={formData.nombre}
            onChange={handleInputChange}
            placeholder="Nombre"
            className="block w-80 p-1 border border-gray-300 rounded"
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="tipoDeDocumento" className="block text-sm font-medium text-gray-700">
            Tipo de Documento
          </label>
          <input
            type="text"
            name="tipoDeDocumento"
            id="tipoDeDocumento"
            value={formData.tipoDeDocumento}
            onChange={handleInputChange}
            placeholder="Tipo de Documento"
            className="block w-80 p-1 border border-gray-300 rounded"
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
        <div className="space-y-2 flex-1">
          <label htmlFor="fecha" className="block text-sm font-medium text-gray-700">
            Fecha
          </label>
          <input
            type="date"
            name="fecha"
            id="fecha"
            value={formData.fecha}
            onChange={handleInputChange}
            className="block w-80 p-1 border border-gray-300 rounded"
          />
        </div>
        <div className="flex-1 flex items-end">
          <button type="submit" className="block w-80 p-1 bg-blue-500 text-white rounded hover:bg-blue-700">
            Buscar
          </button>
        </div>
      </div>
    </form> */}

    <form onSubmit={handleSubmit}>
          <div className="flex mt-3">
            <div className="w-1/3 mb-3 xl:w-96 px-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Codigo Cirugia
              </label>
              <div className="flex">
                <input
                  value={formData.codigoCirugia}
                  onChange={handleInputChange}
                  name="codigoCirugia"
                  type="text"
                  autoComplete="off"
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            
            <div className="w-1/3 mb-3 xl:w-96 px-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Número Documento Iden.
              </label>
              <div className="flex">
                <input
                  type="text"
                  name="numeroDeDocumento"
                  id="numeroDeDocumento"
                  value={formData.numeroDeDocumento}
                  onChange={handleInputChange}
                  autoComplete="off"
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div className="flex">
            
            {/* <div className="w-1/3 mb-3 xl:w-96 px-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Fecha
              </label>
              <div className="flex">
                <input
                   type="date"
                   name="fecha"
                   id="fecha"
                   value={formData.fecha}
                   onChange={handleInputChange}
                  className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  
                  placeholder=""
                />
              </div>
            </div> */}
            <div className="w-1/3 px-3 py-3">
              <button
                type="submit"
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                Buscar
              </button>
            </div>
          </div>
    </form>
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="text-gray-700 bg-gray-100">
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold"></th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Código Cirugía</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Nombre</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Numero Documento</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Tipo Documento</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Fecha</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Hora Inicio</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Hora Final</th>
            <th className="py-2 px-4 border-b border-gray-300 text-left text-sm font-semibold">Contrato</th>
          </tr>
        </thead>
        <tbody>
          {dataUser.map((item, index) => (
            <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-200`}>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">
                <button 
                //type="button"
                onClick={() => handleOnClickProcedimientos(item)}
                    className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                    Seleccionar
                </button>
              </td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.ProCirCod}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.MPNOMC}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.MPCedu}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.MPTDoc}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.FecIniCir}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.HorIniCir}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.HorFinCir}</td>
              <td className="py-2 px-4 border-b border-gray-300 text-sm">{item.ProEPS}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {modalOnProcedimientosQx? <ModalProcedimientosRecordAnestesia setmodalOnProcedimientosQx={setmodalOnProcedimientosQx} dataUserDiligenciar={dataUserDiligenciar}/>:null}
    </>
  );
}


export default RecordAnestesia